/**
 * 桌面版下载：按当前系统取安装包地址
 *
 * 现状：只有 Windows 安装包（.exe）；Mac 版还在开发中，没有下载地址。
 * 所有「下载桌面版」入口统一走这里，没包时给提示，不再跳空链接或门户页。
 */
import { DESKTOP_DOWNLOAD_URL_MAC, DESKTOP_DOWNLOAD_URL_WIN } from '@/config/global'

/** 系统类型：只区分 Win / Mac，其余（Linux 等）归为 other */
export type DesktopOs = 'windows' | 'mac' | 'other'

export interface DesktopDownload {
  os: DesktopOs
  /** 安装包地址：当前系统暂无包时为空串 */
  url: string
  /** 是否有可下载的包 */
  available: boolean
  /** 没有包时的提示文案 */
  tip: string
}

/** 判断当前系统（Mac 判在 Win 之后：iPad 伪装成 Macintosh 时 UA 也不含 Windows） */
export function detectDesktopOs(): DesktopOs {
  if (typeof navigator === 'undefined') return 'other'
  const ua = navigator.userAgent || ''
  if (/Windows|Win32|Win64/i.test(ua)) return 'windows'
  if (/Macintosh|Mac OS X|MacIntel/i.test(ua)) return 'mac'
  return 'other'
}

/**
 * 当前系统的下载信息
 *
 * Windows 拿 .exe；Mac 版开发中，url 为空 + 提示文案；
 * 其它系统同样没有包，提示去用 Windows 版。
 */
export function resolveDesktopDownload(): DesktopDownload {
  const os = detectDesktopOs()
  if (os === 'mac') {
    return { os, url: DESKTOP_DOWNLOAD_URL_MAC, available: !!DESKTOP_DOWNLOAD_URL_MAC, tip: 'Mac 版还在开发中，暂未提供下载，敬请期待' }
  }
  if (os === 'windows') {
    return { os, url: DESKTOP_DOWNLOAD_URL_WIN, available: !!DESKTOP_DOWNLOAD_URL_WIN, tip: '暂未配置 Windows 安装包地址，请联系客服获取' }
  }
  return { os, url: '', available: false, tip: '暂未提供当前系统的安装包，桌面版目前支持 Windows' }
}
